import { createAppSelector } from 'store/hooks';

export const packAndFocusEditorSelector = createAppSelector(
  [
    (state) => state.setting.mode,
    (state) => state.habitPack.packEditorTabMode,
    (state) => state.setting.currentSettings,
    (state) => state.setting.isTextEditorWithinCharacterLimit,
    (state) => state.setting.routineTimeValidation,
    (state) => state.user.isUserAdmin,
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.setting.isShowRoutineModal
  ],
  (
    mode,
    packEditorTabMode,
    currentSettings,
    isTextEditorWithinCharacterLimit,
    routineTimeValidation,
    isUserAdmin,
    currentViewedFocusTemplate,
    isShowRoutineModal
  ) => {
    return {
      mode,
      packEditorTabMode,
      currentSettings,
      isTextEditorWithinCharacterLimit,
      routineTimeValidation,
      isUserAdmin,
      currentViewedFocusTemplate,
      isShowRoutineModal
    };
  }
);

export const packAndFocusEditorHookSelector = createAppSelector(
  [
    (state) => state.habitPack.isPackAndFocusEditorOpen,
    (state) => state.habitPack.editorType,
    (state) => state.habitPack.editorMode,
    (state) => state.habitPack.packEditorTabMode,
    (state) => state.setting.currentSettings,
    (state) => state.habitPack.initialCurrentViewedPack,
    (state) => state.focusMode.initialCurrentViewedFocusTemplate,
    (state) => state.focusMode.currentViewedFocusTemplate
  ],
  (
    isPackAndFocusEditorOpen,
    editorType,
    editorMode,
    packEditorTabMode,
    currentSettings,
    initialCurrentViewedPack,
    initialCurrentViewedFocusTemplate,
    currentViewedFocusTemplate
  ) => {
    return {
      isPackAndFocusEditorOpen,
      editorType,
      editorMode,
      packEditorTabMode,
      currentSettings,
      initialCurrentViewedPack,
      initialCurrentViewedFocusTemplate,
      currentViewedFocusTemplate
    };
  }
);
